import React from "react";
import { sumBy } from "lodash";

import { numberFormat } from "./format";
import { pickMillions } from "./utils";
import OnePanelChart from "./OnePanelChart";
import Text from "./Text";

const Shares = ({
  constants,
  metrics,
  teams,
  competitionMetrics,
  stockRepurchased,
  equities,
  teamId,
  round,
  roundId
}) => {
  const repurchased = stockRepurchased.find(item => item.round === roundId);

  return (
    <OnePanelChart
      title="Shares Issued & Outstanding"
      prefix=""
      suffix="M"
      data={pickMillions(teams, competitionMetrics, "Shares")}
      precision={0}
      teams={teams}
    >
      <Text>
        Your business is authorized to issue up to{" "}
        {numberFormat(constants["authorized_shares"])} shares. In this round,
        you did the following:
      </Text>
      <Text>
        Issued{" "}
        {numberFormat(
          sumBy(equities, item =>
            item.team === teamId && item.round === roundId
              ? item["issuance"]
              : 0
          ) + (round === 1 ? constants["initial_shares"] : 0)
        )}{" "}
        shares
      </Text>
      <Text>
        Repurchased {repurchased ? numberFormat(repurchased.shares) : "0"} shares
      </Text>
      <Text>
        This resulted in total outstanding shares of{" "}
        {numberFormat(metrics["Shares"])}.
      </Text>
    </OnePanelChart>
  );
};

export default Shares;



// WEBPACK FOOTER //
// ./src/components/analysis/Shares.js